import React from "react";
import { PageNewState, CommentDialogInitialState } from ".";

export const CommentDialogContext = React.createContext({
  pageState: CommentDialogInitialState,
  setPageState: (pageState: PageNewState) => {},
});
